import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=f508ae64&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=js&"
export * from "./newIndex.vue?vue&type=script&lang=js&"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=f508ae64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508ae64",
  null
  
)

export default component.exports